export const PAGE_SLUGS = {
    PROGRAMS: 'program-page',
    ABOUT_HYPPOTHERAPY: 'about-hippotherapy',
    DONATE: 'donate-page',
};
